export default function getBirthFromId(idCard: string|null): string|null {
  let birthday = null
  if (idCard !== null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = '19' + idCard.slice(6, 12)
    } else if (idCard.length === 18) {
      birthday = idCard.slice(6, 14)
    }
    if(birthday) birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
    //通过正则表达式来指定输出格式为:1990-01-01
  }
  return birthday
}
